import {Rental} from '../../../../common/types/rental'
import {onlyUnique} from '../../../../common/utils/arrayUtils/onlyUnique'
import {resolveBoxDisplayName} from '../../../../common/utils/resolveBoxDisplayName'

export const getUniqueBoxDisplayNames = (rentals: Rental[]) => rentals.map((rental) => resolveBoxDisplayName(rental.box)).filter(onlyUnique)
